import { css } from '@creditas/stylitas'

import { rtNamespace } from './variables'

const closeButton = css`
  .${rtNamespace}__close-button {
    color: black;
    font-weight: bold;
    font-size: 14px;
    background: transparent;
    outline: none;
    border: none;
    padding: 0;
    cursor: pointer;
    opacity: 0.7;
    transition: 0.3s ease;
    align-self: flex-start;
    &--default {
      color: #000;
      opacity: 0.3;
    }

    &:hover,
    &:focus {
      opacity: 1;
    }
  }
`

export { closeButton }
